import Utility from './Utility';

export default function MoreStepForm() {
  'use strict';

  let formClass = 'powermail_morestep';

  let fieldsetClass = 'powermail_fieldset';

  let buttonActiveClass = 'powermail_progress_active';

  let that = this;

  this.initialize = function() {
    showListener();
    initializeForms();
  };

  this.showFieldset = function(index, form) {
    if (form.classList.contains(formClass)) {
      hideAllFieldsets(form);
      let fieldsets = getAllFieldsetsOfForm(form);
      Utility.showElement(fieldsets[index]);
      updateButtonStatus(form);
    }
  };

  let initializeForms = function() {
    let moreStepForms = document.querySelectorAll('form.' + formClass);
    for (let i = 0; i < moreStepForms.length; i++) {
      initializeForm(moreStepForms[i]);
    }
  };

  let initializeForm = function(form) {
    form.multiStepForm = that;
    that.showFieldset(0, form);
  };

  let showListener = function() {
    let moreButtons = document.querySelectorAll('[data-powermail-morestep-show]');
    for (let i = 0; i < moreButtons.length; i++) {
      moreButtons[i].addEventListener('click', function(event) {
        let targetFieldset = event.target.getAttribute('data-powermail-morestep-show');
        let validateVisibleFields = ['true', '1'].includes(event.target.getAttribute('data-powermail-morestep-validate'));
        let scrollIntoView = ['true', '1'].includes(event.target.getAttribute('data-powermail-morestep-scroll'));
        let form = event.target.closest('form');

        // validate visible fields if set before proceed
        if (validateVisibleFields
          && !form.powermailFormValidation.validateVisibleFields()
        ) {
          form.powermailFormValidation.scrollToFirstError();
          event.target.blur();
          event.preventDefault();
          return;
        }

        targetFieldset = skipConditionHiddenFieldsets(form, Number.parseInt(targetFieldset, 10));
        if (targetFieldset === null) {
          event.preventDefault();
          return;
        }

        that.showFieldset(targetFieldset, form);
        if (scrollIntoView) {
          getAllFieldsetsOfForm(form)[targetFieldset]?.scrollIntoView({behavior:'smooth'});
        }
      });
    }
  }

  /**
   * @param form
   * @param {number} targetIndex
   * @returns {number|null} null if there is no visible page in that direction
   */
  let skipConditionHiddenFieldsets = function(form, targetIndex) {
    let fieldsets = getAllFieldsetsOfForm(form);
    let step = targetIndex < getActivePageIndex(form) ? -1 : 1;
    for (let i = targetIndex; i >= 0 && i < fieldsets.length; i += step) {
      if (!fieldsets[i].classList.contains('powermail-cond-hidden')) {
        return i;
      }
    }
    return null;
  };

  let hideAllFieldsets = function(form) {
    let fieldsets = getAllFieldsetsOfForm(form);
    for (let i = 0; i < fieldsets.length; i++) {
      Utility.hideElement(fieldsets[i]);
    }
  };

  let updateButtonStatus = function(form) {
    let buttons = form.querySelectorAll('[data-powermail-morestep-current]');
    let activePageIndex = getActivePageIndex(form);
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].classList.remove(buttonActiveClass);
      if (i === activePageIndex) {
        buttons[i].classList.add(buttonActiveClass);
      }
    }
  };

  /**
   * Get index of current visible fieldset
   *
   * @param form
   * @returns {number}
   */
  let getActivePageIndex = function(form) {
    let fieldsets = getAllFieldsetsOfForm(form);
    for (let i = 0; i < fieldsets.length; i++) {
      if (fieldsets[i].style.display !== 'none') {
        return i;
      }
    }
  }

  let getAllFieldsetsOfForm = function(form) {
    return form.querySelectorAll('.' + fieldsetClass);
  };
}
